
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stay-current",
      function () {
        return require("private-next-pages/stay-current.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stay-current"])
      });
    }
  